import { createFileRoute, redirect } from '@tanstack/react-router'

/** No landing screen in the app — the client's overview is where you start. */
export const Route = createFileRoute('/')({
  beforeLoad: () => {
    throw redirect({ to: '/klient/prehled' })
  },
})
